// src/pages/ForgotPassword.tsx
import React, { useState, ChangeEvent, FormEvent } from "react";
import { Box, Paper, Typography, TextField, Button, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    // Aquí se haría una llamada a la API para enviar el email de recuperación.
    // Por ejemplo, utilizando fetch o RTK Query.
    // Ejemplo:
    // await api.forgotPassword(email);
    setMessage(
      "Si el correo está registrado, recibirás un email de recuperación."
    );
    // Podrías redirigir al login o dejar el mensaje en la pantalla.
  };

  return (
    <Paper sx={{ padding: 4, maxWidth: 400, margin: "auto", mt: 8 }}>
      <Typography variant="h5" align="center" gutterBottom>
        Recuperar Contraseña
      </Typography>
      <Typography variant="body2" align="center" gutterBottom>
        Ingresa tu correo electrónico para recibir instrucciones de
        recuperación.
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Correo electrónico"
          variant="outlined"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setEmail(e.target.value)
          }
          required
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
        >
          Enviar Instrucciones
        </Button>
      </form>
      {message && (
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          sx={{ mt: 2 }}
        >
          {message}
        </Typography>
      )}
      <Box sx={{ mt: 2, textAlign: "center" }}>
        <Link href="/login" variant="body2">
          Volver al login
        </Link>
      </Box>
    </Paper>
  );
};

export default ForgotPassword;
